









































import { Vue, Component, Prop } from 'vue-property-decorator'
import { WingBlank } from '@/components/index'
import { AddObject, ObjectDetail, ObjectUpdata } from '@/api/ObectAdmin'
import { ReqAddObject } from '@/types/ObjectAdmin'
@Component({
  components: {
    WingBlank,
  },
})
export default class Main extends Vue {
  /**
   * name 对象名称
   * description 对象说明
   * code 对象编码
   */
  form: ReqAddObject = {
    name: '',
    description: '',
    code: '',
  };
  type:any = 'add'
  created() {
    const { query } = this.$route
    const { type } = query
    this.type = type
    if (type === 'edit') {
      const { id } = query
      this.getObjectDetail(id)
    }
  }
  async getObjectDetail(id:any) {
    const { data } = await ObjectDetail(id - 0)
    this.form = data
  }
  async handleSubmit() {
    const { type } = this
    if (type === 'add') {
      await AddObject(this.form)
    } else {
      await ObjectUpdata(this.form)
    }

    this.$router.go(-1)
  }
}
